import "../../../../static/styles/LeakSeverityFilter.css";
import { useState } from "react";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BarrelIcon from "../../../components/SVG/BarrelIcon";
import LeakIcon from "./LeakIcon";

const LeakSeverityFilter = ({ setSeverityFilter }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const severityTypes = [0, 1, 2, 3];
  const [activeButtons, setActiveButtons] = useState([severityTypes[0]]);
  const theme = useTheme();

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  const getButtonColor = (severity) => {
    switch (severity) {
      case 0:
        return "rgb(128, 130, 255)"; // Unknown
      case 1:
        return "rgb(232, 240, 0)"; // Minor
      case 2:
        return "rgb(237, 140, 45)"; // Moderate
      case 3:
        return "rgb(218, 29, 26)"; // Major
      default:
        return "#FFFFFF"; // Default color
    }
  };

  const getButtonTitle = (btnName) => {
    switch (btnName) {
      case 0:
        return "No filter";
      case 1:
        return "Filter by Minor observations";
      case 2:
        return "Filter by Moderate observations";
      case 3:
        return "Filter by Major observations";
      default:
        return "";
    }
  };

  const handleButtonClick = (severity) => {
    setActiveButtons((prevState) => {
      if (severity === 0) {
        setSeverityFilter([0]);
        return [0];
      } else {
        if (prevState.includes(severity)) {
          const newState = prevState.filter((item) => item !== severity);
          setSeverityFilter(newState);
          return newState;
        } else {
          const newState = [
            ...prevState.filter((item) => item !== 0),
            severity,
          ];
          setSeverityFilter(newState);
          return newState;
        }
      }
    });
  };

  return (
    <Box
      className={`severity-filter-container ${isExpanded ? "expanded" : "retracted"}`}
    >
      <Tooltip title="Severity filter selector">
        <IconButton
          className={`severity-button ${isExpanded ? "expanded" : "retracted"}`}
          onClick={toggleExpansion}
          sx={{
            color: theme.palette.primary.white,
            borderRadius: "4px",
            "&:hover": {
              background: theme.palette.primary.buttonSelected,
            },
          }}
        >
          <BarrelIcon />
        </IconButton>
      </Tooltip>
      {severityTypes.map((severity, index) => (
        <Tooltip key={index} title={getButtonTitle(severity)}>
          <IconButton
            className={`severity-button ${activeButtons.includes(severity) ? "active" : ""}`}
            onClick={() => handleButtonClick(severity)}
            sx={{
              color: getButtonColor(severity),
              background: "#fff",
              backgroundColor: "rgb(255, 255, 255)",
              border: "2px solid rgba(0,0,0,0.2)",
              margin: "0",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "24px",
              width: "100%",
              padding: "6px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "background-color 0.3s ease, transform 0.3s ease",
              "&:hover": {
                backgroundColor: theme.palette.primary.buttonSelected,
              },
            }}
          >
            {severity === 0 ? (
              <CloseIcon />
            ) : (
            <LeakIcon severity={severity} />
            )}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export default LeakSeverityFilter;
